import React, { useEffect, useState } from "react";
import logo from '../../components/images/ttel.png';
import { useGetEvents } from "../../components/services/operation.service";
import { Button, Form, notification, Select } from "antd";
import { useNavigate } from "react-router-dom";
import GeoAddress from "../../components/GeoAddress";
import { useAuthContext } from "../../components/Context";

function Events() {

    const { event, setEvent } = useAuthContext();

    const navigate = useNavigate();

    const [events, setEvents] = useState([]);
    const [eventPayload, setEventPayload] = useState(event?.id || '');

    const { data: eventData, isFetched: isEventFetched } = useGetEvents();

    useEffect(() => {

        if (isEventFetched && eventData?.data) {
            let activeEvents = eventData.data.filter(event => event?.isActive);
            setEvents(activeEvents);
        }
    }, [isEventFetched, eventData?.data]);

    // const handleSubmit = () => {

    //     let selectedEvent = events.find(event =>  event?.id === eventPayload);

    //     if(selectedEvent?.id > 0){
    //         sessionStorage.setItem('participant_event', JSON.stringify(selectedEvent));
    //         setEvent(selectedEvent);
            
    //         navigate('/register');
    //     }else{
    //         notification.info({message:'Please select an event?...'});
    //     }
    // }

    return (
        <div style={{ textAlign: 'center' }}>
            {/* <img src={logo} alt="T-tel Logo" style={{ maxWidth: '120px' }} /> */}
            <h2>Workshop Event Details</h2>
            <hr />
            <div style={{ padding: '20px', margin: '0 auto', maxWidth: '300px', minHeight: '250px', textAlign: 'left' }}>
                {/* {JSON.stringify(event)} */}

                <table style={{border: 'none'}} cellPadding={5}>
                    <tbody>
                        <tr>
                            <td>Workshop Name: </td>
                            <td><b>{event?.name}</b></td>
                        </tr>
                        <tr>
                            <td>Description: </td>
                            <td><b>{event?.description}</b></td>
                        </tr>
                        <tr>
                            <td>Start Date: </td>
                            <td><b>{event?.startDate}</b></td>
                        </tr>
                        <tr>
                            <td>End Date: </td>
                            <td><b>{event?.endDate}</b></td>
                        </tr>
                    </tbody>
                </table>

                

                <div style={{display:'none'}}>
                    <GeoAddress />
                </div>
            </div>
            <Button type="primary" onClick={() => navigate('/register')}>Proceed</Button>
        </div>
    );
}

export default Events;
